export * from './core';
export * from './components';
export * from './core/interfaces/config.interface';
export * from './core/interfaces/ai-assistant.interface';
export * from './lib/routes';
export * from './assets/i18n/ai-assistant-i18n.module';
